import EditIcon from '@mui/icons-material/Edit';
import {
    Box,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    IconButton,
    Radio,
    RadioGroup,
    Typography,
} from '@mui/material';

import { CustomInput } from 'src/components/CustomInput';
import { DEFAULT_BORDER } from 'src/constants';

const UserConfig = ({
    toggleOpenConfigForm,
    editConfig,
    setFieldValue,
    handleChange,
    values,
    errors,
}) => {
    if (!values) {
        return null;
    }

    const {
        isWorldPaySeller,
        sellerId,
        isPipeDriveUser,
        pipeDriveUserId,
        hasTechnicalSupportAccess,
        zenDeskUserId,
    } = values;

    const { sellerIDError, pipeDriveUserIDError, zenDeskUserIDError } = errors;

    return (
        <Grid
            item
            xs={12}
            sx={{
                ...DEFAULT_BORDER,
                backgroundColor: '#FFFFFF',
                boxShadow: '0px 4px 20px rgba(38, 50, 56, 0.1)',
                padding: '32px 24px',
            }}
            container
            gap="24px"
        >
            <Grid
                item
                xs={12}
                display="flex"
                justifyContent="space-between"
                sx={{ borderBottom: '1px solid #F18F34' }}
            >
                <Box display="flex" flexDirection="column" gap="8px" marginBottom="8px">
                    <Typography variant="h2">Configuration</Typography>
                    <Typography>Set user configuration in this section</Typography>
                </Box>
                <IconButton
                    sx={{ color: 'black', '&:hover': { background: 'none' } }}
                    onClick={toggleOpenConfigForm}
                >
                    <EditIcon />
                </IconButton>
            </Grid>

            {editConfig ? (
                <>
                    <Grid item xs={12} spacing={2} container>
                        {/* WorldPay  */}
                        <Grid item xs={12} lg={6}>
                            <Grid
                                item
                                xs={12}
                                lg={6}
                                container
                                direction="row"
                                alignItems="center"
                                gap="8px"
                            >
                                <Grid item>
                                    <FormLabel id="world-pay-seller">WorldPay Seller?</FormLabel>
                                </Grid>
                                <Grid item>
                                    <FormControl component="fieldset">
                                        <RadioGroup
                                            aria-labelledby="world-pay-seller-radio-buttons"
                                            defaultValue={isWorldPaySeller}
                                            name="world-pay-seller-radio-group"
                                            row
                                            onChange={(event) => {
                                                setFieldValue(
                                                    'isWorldPaySeller',
                                                    JSON.parse(event.target.value)
                                                );
                                            }}
                                        >
                                            <FormControlLabel
                                                value={true}
                                                control={<Radio />}
                                                label="Yes"
                                            />
                                            <FormControlLabel
                                                value={false}
                                                control={<Radio />}
                                                label="No"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            {isWorldPaySeller && (
                                <Grid item>
                                    <CustomInput
                                        name="sellerId"
                                        label="Seller ID"
                                        onChange={handleChange}
                                        value={sellerId}
                                        error={sellerIDError}
                                    />
                                </Grid>
                            )}
                        </Grid>

                        {/* Sage User  */}

                        {/* Pipe Drive  */}
                        <Grid item xs={12} lg={6}>
                            <Grid
                                item
                                xs={12}
                                lg={6}
                                container
                                direction="row"
                                alignItems="center"
                                gap="8px"
                            >
                                <Grid item>
                                    <FormLabel id="pipe-drive">Pipe Drive?</FormLabel>
                                </Grid>
                                <Grid item>
                                    <FormControl>
                                        <RadioGroup
                                            aria-labelledby="pipe-drive-radio-buttons"
                                            defaultValue={isPipeDriveUser}
                                            name="pipeDriveUser"
                                            row
                                            onChange={(event) => {
                                                setFieldValue(
                                                    'isPipeDriveUser',
                                                    JSON.parse(event.target.value)
                                                );
                                            }}
                                        >
                                            <FormControlLabel
                                                value={true}
                                                control={<Radio />}
                                                label="Yes"
                                            />
                                            <FormControlLabel
                                                value={false}
                                                control={<Radio />}
                                                label="No"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            {isPipeDriveUser && (
                                <CustomInput
                                    name="pipeDriveUserId"
                                    label="Pipe Drive User ID"
                                    onChange={handleChange}
                                    value={pipeDriveUserId}
                                    error={pipeDriveUserIDError}
                                />
                            )}
                        </Grid>

                        {/* Technical Support Access  */}
                        <Grid item xs={12} lg={6}>
                            <Grid item container direction="row" alignItems="center" gap="8px">
                                <Grid item>
                                    <FormLabel id="technical-support-access">
                                        Technical Support Access?
                                    </FormLabel>
                                </Grid>
                                <Grid item>
                                    <FormControl sx={{ display: 'flex' }}>
                                        <RadioGroup
                                            aria-labelledby="tech-support-access-radio-buttons"
                                            defaultValue={hasTechnicalSupportAccess}
                                            name="tech-support-access-radio-group"
                                            row
                                            onChange={(event) => {
                                                setFieldValue(
                                                    'hasTechnicalSupportAccess',
                                                    JSON.parse(event.target.value)
                                                );
                                            }}
                                        >
                                            <FormControlLabel
                                                value={true}
                                                control={<Radio />}
                                                label="Yes"
                                            />
                                            <FormControlLabel
                                                value={false}
                                                control={<Radio />}
                                                label="No"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            {hasTechnicalSupportAccess && (
                                <CustomInput
                                    name="zenDeskUserId"
                                    label="ZenDesk User ID"
                                    onChange={handleChange}
                                    value={zenDeskUserId}
                                    error={zenDeskUserIDError}
                                />
                            )}
                        </Grid>
                    </Grid>
                </>
            ) : !isWorldPaySeller && !isPipeDriveUser && !hasTechnicalSupportAccess ? (
                <>
                    <Grid item xs={12} spacing={2} container>
                        <Grid item xs={12} lg={6}>
                            <Box display="flex" flexDirection="column" gap="24px">
                                <Typography sx={{ fontSize: '20px', fontWeight: 400 }}>
                                    Nothing Configured For This User
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </>
            ) : (
                <>
                    <Grid item xs={12} spacing={2} container>
                        {/* WorldPay  */}
                        {isWorldPaySeller && (
                            <Grid item xs={12} lg={6}>
                                <Box display="flex" flexDirection="column" gap="24px">
                                    <Typography
                                        sx={{
                                            fontSize: '14px',
                                            fontWeight: 600,
                                        }}
                                    >
                                        Seller ID
                                    </Typography>
                                    <Typography
                                        sx={{ fontSize: '20px', fontWeight: 400, color: '#8E8E8D' }}
                                    >
                                        {sellerId}
                                    </Typography>
                                </Box>

                                <Grid
                                    item
                                    xs={12}
                                    lg={6}
                                    container
                                    direction="row"
                                    alignItems="center"
                                    gap="8px"
                                >
                                    <Grid item>
                                        <FormLabel id="world-pay-seller" sx={{ color: '#434341' }}>
                                            WorldPay Seller
                                        </FormLabel>
                                    </Grid>
                                    <Grid item>
                                        <FormControl component="fieldset">
                                            <RadioGroup
                                                aria-labelledby="world-pay-seller-radio-buttons"
                                                value={isWorldPaySeller}
                                                name="isWorldPaySeller"
                                                row
                                            >
                                                <FormControlLabel
                                                    value={true}
                                                    disabled
                                                    control={<Radio />}
                                                    label="Yes"
                                                />
                                                <FormControlLabel
                                                    value={false}
                                                    disabled
                                                    control={<Radio />}
                                                    label="No"
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}

                        {/* Sage User  */}

                        {/* Pipe Drive  */}
                        {isPipeDriveUser && (
                            <Grid item xs={12} lg={6}>
                                <Box display="flex" flexDirection="column" gap="24px">
                                    <Typography
                                        sx={{
                                            fontSize: '14px',
                                            fontWeight: 600,
                                        }}
                                    >
                                        Pipe Drive User ID
                                    </Typography>
                                    <Typography
                                        sx={{ fontSize: '20px', fontWeight: 400, color: '#8E8E8D' }}
                                    >
                                        {pipeDriveUserId}
                                    </Typography>
                                </Box>
                                <Grid
                                    item
                                    xs={12}
                                    lg={6}
                                    container
                                    direction="row"
                                    alignItems="center"
                                    gap="8px"
                                >
                                    <Grid item>
                                        <FormLabel id="pipe-drive" sx={{ color: '#434341' }}>
                                            Pipe Drive
                                        </FormLabel>
                                    </Grid>
                                    <Grid item>
                                        <FormControl>
                                            <RadioGroup
                                                aria-labelledby="pipe-drive-radio-buttons"
                                                value={isPipeDriveUser}
                                                name="pipe-drive-radio-group"
                                                row
                                            >
                                                <FormControlLabel
                                                    value={true}
                                                    control={<Radio />}
                                                    label="Yes"
                                                />
                                                <FormControlLabel
                                                    value={false}
                                                    control={<Radio />}
                                                    label="No"
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}

                        {/* Technical Support Access  */}
                        {hasTechnicalSupportAccess && (
                            <Grid item xs={12} lg={6}>
                                <Box display="flex" flexDirection="column" gap="24px">
                                    <Typography
                                        sx={{
                                            fontSize: '14px',
                                            fontWeight: 600,
                                        }}
                                    >
                                        ZenDesk User ID
                                    </Typography>
                                    <Typography
                                        sx={{ fontSize: '20px', fontWeight: 400, color: '#8E8E8D' }}
                                    >
                                        {zenDeskUserId}
                                    </Typography>
                                </Box>
                                <Grid
                                    item
                                    xs={12}
                                    lg={6}
                                    container
                                    direction="row"
                                    alignItems="center"
                                    gap="8px"
                                >
                                    <Grid item>
                                        <FormLabel
                                            id="technical-support-access"
                                            sx={{ color: '#434341' }}
                                        >
                                            Technical Support Access
                                        </FormLabel>
                                    </Grid>
                                    <Grid item>
                                        <FormControl sx={{ display: 'flex' }}>
                                            <RadioGroup
                                                aria-labelledby="tech-support-access-radio-buttons"
                                                value={hasTechnicalSupportAccess}
                                                name="tech-support-access-radio-group"
                                                row
                                            >
                                                <FormControlLabel
                                                    value={true}
                                                    control={<Radio />}
                                                    label="Yes"
                                                />
                                                <FormControlLabel
                                                    value={false}
                                                    control={<Radio />}
                                                    label="No"
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </>
            )}
        </Grid>
    );
};

export default UserConfig;
